angular.module('hjApp.user', ['ipCookie', 'ui.router', 'restangular', 'hjApp.api', 'hjApp.models', 'hjApp.plans']);
